import PageHeader from '@common/PageHeader'
import VTable from '@common/Table'
import {
  isWeddingDressProperty,
  isWeddingRingJewelryProperty
} from '@merchant-backend/util'
import { Radio } from 'hljd'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import { DragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import { Link } from 'react-router'
import store from '../../store'
import Menu from './Menu'
import Modal from './Modal'
import Property from './Property'
import SearchBar from './SearchBar'
import SortBar from './SortBar'
import style from './style.module.less'
import Table from './Table'

@DragDropContext(HTML5Backend)
@observer
export default class extends Component {
  componentDidMount() {
    store.getPropertyList()
    store.merchantCategory()
    store.getMenuList()
    // 灰度城市查询
    store.getGrayCity()
    if (this.props.tab) {
      store.changeTab(this.props.tab)
    }
  }

  render() {
    const {
      key,
      isSort,
      reviewText,
      coverPathText,
      noSetAreaText,
      title_search,
      searchNum,
      changeTab
    } = store
    return (
      <div className={style.content}>
        {isWeddingDressProperty() ? (
          <PageHeader
            type="error"
            title="亲爱的商家，由于用户端频道优化，案例将不再有曝光入口，我们将在12月关闭后台功能。在此之前，您可将展示单款产品的案例快捷发布到款式。"
            wrapStyle={{
              flex: 'none',
              marginBottom: '24px'
            }}
            style={{
              lineHeight: '30px',
              height: 'auto'
            }}
          />
        ) : null}
        {!!title_search && <Property />}
        {!!title_search ? null : (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {reviewText ? (
              <PageHeader
                type="error"
                key="reviewText"
                title={reviewText}
                wrapStyle={{
                  flex: 'none',
                  marginBottom: '8px'
                }}
                style={{
                  height: 'auto'
                }}
                extra={<Link to="/localMerchant/case/auditList">点击查看</Link>}
              />
            ) : null}

            {coverPathText || noSetAreaText ? (
              <PageHeader
                type="error"
                title={`${noSetAreaText || coverPathText}`}
                wrapStyle={{
                  flex: 'none',
                  marginBottom: isWeddingRingJewelryProperty() ? '8px' : '24px'
                }}
                key="coverPathText"
                extra={
                  <a
                    onClick={() => {
                      store.setStoreData('is_cover_img', '4')
                      changeTab('1')
                    }}
                  >
                    点击查看
                  </a>
                }
              />
            ) : null}

            {isWeddingRingJewelryProperty() ? (
              <PageHeader
                type="error"
                title="案例模块将于2021年09月30日下线，您可将现有案例发布为动态。"
                wrapStyle={{ flex: 'none', marginBottom: '24px' }}
                key="coverPathText"
                extra={
                  <a
                    href="https://qnm.hunliji.com/FtZXcpjKleJaYY1IC2PZnf2VqO5b"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    查看详细说明
                  </a>
                }
              />
            ) : null}
          </div>
        )}
        <div className={style.tableBox}>
          {!title_search && (
            <Radio.Group
              value={key}
              className={style.radioGroup}
              onChange={e => changeTab(e.target.value)}
            >
              <Radio.Button value="1">已上架</Radio.Button>
              <Radio.Button value="4">已下架</Radio.Button>
              {store.grayTestFlag && (
                <Radio.Button value="5">违规</Radio.Button>
              ) // xin_tian屏蔽
              }
            </Radio.Group>
          )}

          {!!title_search && (
            <div className={style.searchNum}>
              {searchNum
                ? `找到与「${title_search}」相关的 ${searchNum} 条结果`
                : `未找到于「${title_search}」相关的结果，可以搜索其他内容或`}
              <span onClick={() => store.onTitleChange('')}>清空搜索结果</span>
            </div>
          )}

          <div className={style.contentWrap}>
            {!store.showViolation && (
              <>
                <div className={style.categoryWrap}>
                  <Menu />
                </div>
                <div className={style.tableWrap}>
                  {!!title_search ? null : isSort ? <SortBar /> : <SearchBar />}
                  <Table />
                </div>
              </>
            )}
            {store.showViolation && (
              <VTable
                loading={store.violationLoading}
                style={{ width: '100%' }}
                className="violation"
                rowKey="key"
                columns={[
                  {
                    title: '违规类型',
                    dataIndex: 'type',
                    key: 'type'
                  },
                  {
                    title: '违规案例',
                    dataIndex: 'caseName',
                    key: 'caseName',
                    ellipsis: true,
                    width: 240,
                    render: (text, record) => {
                      return text ? (
                        <a
                          className={style.outsideLnk}
                          onClick={store.toEdit(record)}
                        >
                          {text}
                        </a>
                      ) : (
                        '案例已删除'
                      )
                    }
                  },
                  {
                    title: '违规通知时间',
                    dataIndex: 'noticeTime',
                    key: 'noticeTime'
                  },
                  {
                    title: '处罚结果',
                    dataIndex: 'punishResult',
                    key: 'punishResult'
                  },
                  {
                    title: '处罚开始时间',
                    dataIndex: 'punishTime',
                    key: 'punishTime'
                  },
                  {
                    title: '处罚状态',
                    dataIndex: 'punishState',
                    key: 'punishState'
                  }
                ]}
                dataSource={toJS(store.violationList)}
                pagination={{
                  current: store.violationPageNum,
                  defaultCurrent: 1,
                  showSizeChanger: true,
                  total: store.violationTotal,
                  pageSize: store.violationPageSize,
                  showTotal: total => (
                    <div>
                      <span>{`共${total}条`}</span>
                      <div
                        style={{
                          position: 'absolute',
                          left: 20,
                          bottom: 10,
                          fontSize: 12,
                          color: '#666'
                        }}
                      >
                        仅显示近1年违规记录
                      </div>
                    </div>
                  ),
                  onChange: e => {
                    store.setViolationPageNum(e)
                    // this.getList()
                  },
                  onShowSizeChange: (index, size) => {
                    store.setViolationPageSize(size)
                  }
                }}
              />
            )}
          </div>

          <Modal />
        </div>
      </div>
    )
  }
}
